import star from "../assets/images/star.png";
import avatar11 from "../assets/images/avatar-11.png";
import avatar12 from "../assets/images/avatar-12.png";
import avatar13 from "../assets/images/avatar-13.png";
import avatar14 from "../assets/images/avatar-14.png";
import avatar1 from "../assets/images/avatar-6.png";
import avatar2 from "../assets/images/avatar-7.png";
import avatar3 from "../assets/images/avatar-3.png";
import avatar4 from "../assets/images/avatar-8.png";
import avatar5 from "../assets/images/avatar-9.png";
import { Helmet } from "react-helmet";

export default function Reviews() {
  const reviews = [
    {
      avatar: avatar3,
      name: "Mia S.",
      rating: 5,
      testimonial:
        "I'm a fitness enthusiast, and I decided to try buying real likes. It genuinely helped increase engagement on my posts, motivating me to push my fitness journey further.",
    },
    {
      avatar: avatar4,
      name: "Natalie R.",
      rating: 5,
      testimonial:
        "I'm a foodie, and after getting likes, I noticed more people appreciating my culinary creations. It's been a great confidence booster!",
    },
    {
      avatar: avatar1,
      name: "Jacob B.",
      rating: 5,
      testimonial: "Boosed my credibility and visibility. This is a growth hack.",
    },
    {
      avatar: avatar2,
      name: "Diana G.",
      rating: 5,
      testimonial:
        "The ease of use and the effectiveness of this service are unmatched. I've seen a real increase in engagement on all my posts, making my social media strategy more successful than ever.",
    },
    {
      avatar: avatar5,
      name: "Kate J.",
      rating: 5,
      testimonial:
        "The Instagram algorithm is not working in our favor at the moment. Looking for alternative solutions I found this service and it made a massive change to my profile! Love it!",
    },
    {
      avatar: avatar11,
      name: "David G.",
      rating: 5,
      testimonial: "Such a smooth and simple ordering process. Super fast delivery!",
    },
    {
      avatar: avatar12,
      name: "Ethan",
      rating: 5,
      testimonial:
        "If you're struggling with social media growth, this is the solution. I saw a substantial increase in likes and comments on my posts, making my profile much more vibrant and attractive.",
    },
    {
      avatar: avatar13,
      name: "Oliver W.",
      rating: 5,
      testimonial:
        "Great value for money! The results exceeded my expectations, and I didn't have to break the bank to get my social media accounts where I wanted them to be.",
    },
    {
      avatar: avatar14,
      name: "Jenna R.",
      rating: 5,
      testimonial:
        "I've tried other services before, but none have been as effective and efficient as this one. My TikTok account has gained so much traction, and I'm finally reaching my target audience.",
    },
  ];

  return (
    <section className="my-20">
      <Helmet>
        <title>Dailysocialboost | Testimonials</title>
      </Helmet>
      <h2 className="text-center text-5xl font-bold my-10">Testimonials</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-3 lg:gap-5">
        {reviews.map((review, idx) => (
          <div className="border rounded-xl border-gray-350 p-5" key={idx}>
            <div className="flex flex-row gap-5">
              <div>
                <img src={review.avatar} alt={review.name} className="max-h-14 max-w-14" />
              </div>
              <div>
                <h2 className="font-semibold">{review.name}</h2>
                <div className="flex flex-row">
                  {new Array(review.rating).fill(1).map((e, i) => (
                    <img
                      key={`${review.name}-rating-star-idx-${idx}-${i}`}
                      src={star}
                      alt={`Star ${i + 1}`}
                    />
                  ))}
                </div>
              </div>
            </div>
            <p className="my-5">{review.testimonial}</p>
            {/* <a className="my-5 text-pink-350 hover:opacity-80 transition-all" href="https://www.trustpilot.com" target="_blank" rel="noreferrer">Read on trustpilot</a> */}
          </div>
        ))}
      </div>
    </section>
  );
}
